/**
 * Shared Noirvere sticky cart bar — visibility, variant sync, ATC colors.
 * cache-bust: sticky-price-spacing 2026-06-04
 */
(function () {
  'use strict';

  if (window.__nvStickyCart) return;
  window.__nvStickyCart = true;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function discountPercent(price, compareAt) {
    if (!compareAt || compareAt <= price) return 0;
    return Math.round(((compareAt - price) / compareAt) * 100);
  }

  function hexFromCheckedColor(group) {
    if (!group) return null;
    var checked = group.querySelector('input[type="radio"]:checked');
    var labelEl = null;
    if (checked) {
      labelEl = group.querySelector('label[for="' + checked.id + '"]') || checked.closest('label');
    }
    if (!labelEl) return null;
    var raw = labelEl.getAttribute('style') || '';
    if (!raw) {
      var cs = getComputedStyle(labelEl);
      raw =
        cs.getPropertyValue('--swatch-background') ||
        cs.getPropertyValue('background-image') ||
        cs.getPropertyValue('background') ||
        '';
    }
    var m = raw.match(/#([0-9a-f]{3,6})/i);
    if (!m) return null;
    var hex = m[0];
    if (hex.length === 4) {
      hex = '#' + hex.slice(1).split('').map(function (x) { return x + x; }).join('');
    }
    return hex;
  }

  function findColorGroup(form) {
    var vp =
      document.querySelector('variant-picker[form-id="' + form.id + '"]') ||
      form.closest('.shopify-section--main-product');
    if (!vp) return null;
    var groups = vp.querySelectorAll('.variant-picker__option, fieldset');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (g.querySelector('label[style*="#"]')) return g;
      var lab = g.querySelector('legend, .variant-picker__option-info legend');
      if (lab && /color|colour|couleur|farbe|colore/i.test(lab.textContent)) return g;
    }
    return null;
  }

  function paintAtcButton(btn, hex) {
    if (!btn || !hex) return;
    var clean = hex.replace('#', '');
    if (clean.length === 3) clean = clean.split('').map(function (x) { return x + x; }).join('');
    var r = parseInt(clean.slice(0, 2), 16);
    var g = parseInt(clean.slice(2, 4), 16);
    var b = parseInt(clean.slice(4, 6), 16);
    var triplet = r + ' ' + g + ' ' + b;
    btn.style.setProperty('--button-background', triplet);
    btn.style.setProperty('--button-outline-color', triplet);
    btn.style.backgroundColor = 'rgb(' + r + ', ' + g + ', ' + b + ')';
    btn.style.color = 0.299 * r + 0.587 * g + 0.114 * b > 160 ? '#000' : '#fff';
  }

  function syncAtcColor(form, bar) {
    if (!form || !bar) return;
    var isLanding = bar.getAttribute('data-mode') === 'landing';
    var stickyBtn = bar.querySelector('[data-nv-sticky-atc]');
    var mainBtn = form.querySelector(
      '.buy-buttons button[type="submit"], button[type="submit"][name="add"]'
    );
    if (mainBtn && stickyBtn) {
      if (!isLanding) {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.textContent = mainBtn.textContent.trim() || stickyBtn.textContent;
      }
      var hex = hexFromCheckedColor(findColorGroup(form));
      if (hex) {
        paintAtcButton(stickyBtn, hex);
        return;
      }
      var bg = getComputedStyle(mainBtn).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)') {
        stickyBtn.style.backgroundColor = bg;
        stickyBtn.style.color = getComputedStyle(mainBtn).color;
      }
    }
  }

  function variantFromForm(form) {
    if (!form || !form.id) return null;
    var picker =
      document.querySelector('variant-picker[form-id="' + form.id + '"]') ||
      document.querySelector('variant-picker[form="' + form.id + '"]');
    if (!picker) return null;
    var script = picker.querySelector('script[data-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function imgFromGalleryCell(cell) {
    if (!cell) return null;
    var img = cell.querySelector('img');
    if (!img || !img.src) return null;
    return img;
  }

  function normalizeMediaSrc(src) {
    if (!src) return null;
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function mediaUrlFromVariantMediaObject(media) {
    if (!media) return null;
    if (media.preview_image && media.preview_image.src) {
      return normalizeMediaSrc(media.preview_image.src);
    }
    if (media.src) return normalizeMediaSrc(media.src);
    return null;
  }

  function parseVariantMediaAttr(el) {
    if (!el) return null;
    var raw = el.getAttribute('data-variant-media');
    if (!raw) return null;
    try {
      return mediaUrlFromVariantMediaObject(JSON.parse(raw));
    } catch (e) {
      return null;
    }
  }

  function mediaUrlFromSwatchLabel(checked, picker) {
    if (!checked) return null;
    var label =
      (picker && picker.querySelector('label[for="' + checked.id + '"]')) ||
      checked.closest('label');
    if (!label) return null;
    var thumbImg = label.querySelector('.thumbnail-swatch img, .variant-picker__option img');
    if (thumbImg && thumbImg.src) return thumbImg.currentSrc || thumbImg.src;
    return null;
  }

  function selectedOptionDisplayName(checked, picker) {
    if (!checked) return '';
    var option = checked.closest('.variant-picker__option, fieldset');
    if (option) {
      var span = option.querySelector('.variant-picker__option-info .h-stack span');
      if (span && span.textContent) return span.textContent.trim();
    }
    var label =
      (picker && picker.querySelector('label[for="' + checked.id + '"]')) ||
      checked.closest('label');
    if (label) {
      var sr = label.querySelector('.sr-only');
      if (sr && sr.textContent) return sr.textContent.trim();
      var text = label.textContent.trim();
      if (text) return text;
    }
    return '';
  }

  function mediaUrlForSelectedColor(section, form) {
    var colorGroup = form ? findColorGroup(form) : null;
    if (!colorGroup || !section) return null;
    var checked = colorGroup.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var picker =
      document.querySelector('variant-picker[form-id="' + form.id + '"]') ||
      document.querySelector('variant-picker[form="' + form.id + '"]');
    var colorName = selectedOptionDisplayName(checked, picker);
    if (!colorName) return null;
    var needle = colorName.toLowerCase().replace(/\s+/g, '_');
    var cells = section.querySelectorAll('.product-gallery__media:not([hidden]) img');
    for (var i = 0; i < cells.length; i++) {
      var alt = (cells[i].getAttribute('alt') || '').toLowerCase();
      if (alt.indexOf('#') !== -1 && alt.indexOf(needle) !== -1) {
        return cells[i].currentSrc || cells[i].src;
      }
    }
    return null;
  }

  function mediaUrlFromCheckedOptions(form, section) {
    if (!form || !form.id) return null;
    var picker =
      document.querySelector('variant-picker[form-id="' + form.id + '"]') ||
      document.querySelector('variant-picker[form="' + form.id + '"]');
    if (!picker) return null;

    var checkedInputs = picker.querySelectorAll(
      'input[data-option-position]:checked[data-variant-media]'
    );
    for (var i = 0; i < checkedInputs.length; i++) {
      var fromAttr = parseVariantMediaAttr(checkedInputs[i]);
      if (fromAttr) return fromAttr;
      var fromLabel = mediaUrlFromSwatchLabel(checkedInputs[i], picker);
      if (fromLabel) return fromLabel;
    }

    var colorGroup = form ? findColorGroup(form) : null;
    if (colorGroup) {
      var colorChecked = colorGroup.querySelector('input[type="radio"]:checked');
      if (colorChecked) {
        var colorAttr = parseVariantMediaAttr(colorChecked);
        if (colorAttr) return colorAttr;
        var colorLabel = mediaUrlFromSwatchLabel(colorChecked, picker);
        if (colorLabel) return colorLabel;
      }
    }

    var anyChecked = picker.querySelector('input:checked[data-variant-media]');
    if (anyChecked) {
      var anyAttr = parseVariantMediaAttr(anyChecked);
      if (anyAttr) return anyAttr;
      var anyLabel = mediaUrlFromSwatchLabel(anyChecked, picker);
      if (anyLabel) return anyLabel;
    }

    return mediaUrlForSelectedColor(section, form);
  }

  function resolveVariantMediaUrl(variant, section) {
    if (!variant) return null;
    var fm = variant.featured_media || variant.featured_image;
    if (!fm) return null;

    if (fm.preview_image && fm.preview_image.src) return normalizeMediaSrc(fm.preview_image.src);
    if (fm.src) return normalizeMediaSrc(fm.src);

    if (fm.id && section) {
      var cell = section.querySelector(
        '.product-gallery__media[data-media-id="' + fm.id + '"]'
      );
      var img = imgFromGalleryCell(cell);
      if (img) return img.currentSrc || img.src;
    }

    if (fm.position && section) {
      var byPos = section.querySelector(
        '.product-gallery__media[data-media-position="' + fm.position + '"]'
      );
      var posImg = imgFromGalleryCell(byPos);
      if (posImg) return posImg.currentSrc || posImg.src;
    }

    return null;
  }

  function resolveActiveGalleryImage(section) {
    if (!section) return null;

    var selectedCell = section.querySelector(
      '.product-gallery__media.is-selected:not([hidden])'
    );
    var selectedImg = imgFromGalleryCell(selectedCell);
    if (selectedImg) return selectedImg;

    var carousel = section.querySelector('scroll-carousel, .product-gallery__carousel');
    if (carousel) {
      if (carousel.selectedCell && !carousel.selectedCell.hasAttribute('hidden')) {
        var carouselImg = imgFromGalleryCell(carousel.selectedCell);
        if (carouselImg) return carouselImg;
      }

      var cells = carousel.cells || carousel.querySelectorAll('.product-gallery__media:not([hidden])');
      if (cells && cells.length) {
        var carouselRect = carousel.getBoundingClientRect();
        var centerX = carouselRect.left + carouselRect.width / 2;
        var bestImg = null;
        var bestDist = Infinity;
        for (var c = 0; c < cells.length; c++) {
          var cell = cells[c];
          if (cell.hasAttribute('hidden')) continue;
          var rect = cell.getBoundingClientRect();
          if (rect.width < 1) continue;
          var cellCenter = rect.left + rect.width / 2;
          var dist = Math.abs(cellCenter - centerX);
          if (dist < bestDist) {
            var img = imgFromGalleryCell(cell);
            if (img) {
              bestDist = dist;
              bestImg = img;
            }
          }
        }
        if (bestImg) return bestImg;
      }
    }

    var currentThumb = section.querySelector(
      'product-gallery-navigation [aria-current="true"][data-media-id]'
    );
    if (currentThumb) {
      var mediaId = currentThumb.getAttribute('data-media-id');
      var thumbCell = section.querySelector(
        '.product-gallery__media[data-media-id="' + mediaId + '"]:not([hidden])'
      );
      var thumbImg = imgFromGalleryCell(thumbCell);
      if (thumbImg) return thumbImg;
    }

    return null;
  }

  function applyStickyMedia(bar, src, srcset) {
    if (!bar || !src) return;
    var mediaImg = bar.querySelector('[data-nv-sticky-media-img]');
    var mediaWrap = bar.querySelector('[data-nv-sticky-media]');
    if (!mediaImg) return;
    mediaImg.src = src;
    if (srcset) {
      mediaImg.srcset = srcset;
    } else {
      mediaImg.removeAttribute('srcset');
    }
    if (mediaWrap) mediaWrap.hidden = false;
  }

  function updateFromVariant(bar, variant, form) {
    if (!bar || !variant) return;
    var priceEl = bar.querySelector('[data-nv-sticky-price]');
    var compareEl = bar.querySelector('[data-nv-sticky-compare]');
    var saveEl = bar.querySelector('[data-nv-sticky-save]');
    var atc = bar.querySelector('[data-nv-sticky-atc]');
    var section = document.querySelector(
      bar.getAttribute('data-section-selector') || '.shopify-section--main-product'
    );

    if (priceEl && variant.price != null) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (saveEl) {
      var pct = discountPercent(variant.price, variant.compare_at_price);
      if (pct > 0) {
        saveEl.textContent = '−' + pct + '%';
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    if (atc && bar.getAttribute('data-mode') === 'product') {
      atc.disabled = !variant.available;
    }

    var mediaUrl =
      mediaUrlFromCheckedOptions(form, section) ||
      resolveVariantMediaUrl(variant, section);
    if (mediaUrl) applyStickyMedia(bar, mediaUrl);
  }

  function syncStickyMedia(bar, section, form) {
    if (!bar || !section) return;

    var fromSwatch = mediaUrlFromCheckedOptions(form, section);
    if (fromSwatch) {
      applyStickyMedia(bar, fromSwatch);
      return;
    }

    var variant = variantFromForm(form);
    var fromVariant = resolveVariantMediaUrl(variant, section);
    if (fromVariant) {
      applyStickyMedia(bar, fromVariant);
      return;
    }

    var active = resolveActiveGalleryImage(section);
    if (active) {
      applyStickyMedia(bar, active.currentSrc || active.src, active.srcset || '');
    }
  }

  function visiblePriceText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    var hidden = clone.querySelectorAll('.sr-only, [class~="sr-only"]');
    for (var h = 0; h < hidden.length; h++) {
      hidden[h].remove();
    }
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function syncFromDom(bar, form) {
    if (!bar) return;
    var section = document.querySelector(bar.getAttribute('data-section-selector') || '.shopify-section--main-product');
    if (!section) return;

    var priceStrong = section.querySelector('.price-list sale-price, .price-list .h4');
    var priceCompare = section.querySelector('.price-list compare-at-price');
    var priceEl = bar.querySelector('[data-nv-sticky-price]');
    var compareEl = bar.querySelector('[data-nv-sticky-compare]');
    var saveEl = bar.querySelector('[data-nv-sticky-save]');
    var mediaImg = bar.querySelector('[data-nv-sticky-media-img]');

    if (priceEl && priceStrong) priceEl.textContent = visiblePriceText(priceStrong);
    if (compareEl && priceCompare && !priceCompare.hidden) {
      compareEl.textContent = visiblePriceText(priceCompare);
      compareEl.hidden = false;
      if (saveEl) {
        var priceText = priceEl ? priceEl.textContent.replace(/[^\d.,]/g, '') : '';
        var compareText = compareEl.textContent.replace(/[^\d.,]/g, '');
        var p = parseFloat(priceText.replace(',', '.'));
        var c = parseFloat(compareText.replace(',', '.'));
        if (c > p && p > 0) {
          saveEl.textContent = '−' + Math.round(((c - p) / c) * 100) + '%';
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      }
    } else if (compareEl) {
      compareEl.hidden = true;
      if (saveEl) saveEl.hidden = true;
    }

    syncStickyMedia(bar, section, form);

    if (form) syncAtcColor(form, bar);

    var heroPrice = document.querySelector('.nv-cro-hero__offer-price');
    var heroCompare = document.querySelector('.nv-cro-hero__offer-compare');
    if (heroPrice && priceEl) heroPrice.textContent = priceEl.textContent.trim();
    if (heroCompare) {
      if (compareEl && !compareEl.hidden) {
        heroCompare.textContent = compareEl.textContent.trim();
        heroCompare.hidden = false;
      } else {
        heroCompare.hidden = true;
      }
    }

    var heroImg = document.querySelector('.nv-cro-hero__image');
    if (heroImg && mediaImg && mediaImg.src) {
      heroImg.src = mediaImg.currentSrc || mediaImg.src;
      if (mediaImg.srcset) heroImg.srcset = mediaImg.srcset;
    }
  }

  function initBar(bar) {
    var mode = bar.getAttribute('data-mode') || 'product';
    var formId = bar.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var shopAnchor = bar.getAttribute('data-shop-anchor');
    var mainProduct = document.querySelector(bar.getAttribute('data-section-selector') || '.shopify-section--main-product');
    var hero = document.querySelector(bar.getAttribute('data-hero-selector') || '.nv-cro-hero');

    bar.hidden = false;

    var mobileQuery = window.matchMedia('(max-width: 989px)');
    var shopActive = false;
    var stickyShown = false;

    function setShopActive(active) {
      shopActive = !!active;
      document.documentElement.classList.toggle('nv-shop-active', shopActive);
    }

    function setStickyShown(show) {
      stickyShown = !!show;
      bar.classList.toggle('is-visible', stickyShown);
      document.documentElement.classList.toggle('nv-sticky-visible', stickyShown);
    }

    function isShopVisibleFallback() {
      if (!mainProduct) return false;
      var vh = window.innerHeight;
      var enterAt = mobileQuery.matches ? 0.62 : 0.82;
      var exitAt = mobileQuery.matches ? 0.72 : 0.9;
      var threshold = shopActive ? exitAt : enterAt;
      var rect = mainProduct.getBoundingClientRect();
      return rect.top < vh * threshold && rect.bottom > vh * 0.1;
    }

    function updateVisibility() {
      if (mode === 'landing') {
        var isMobile = mobileQuery.matches;
        var pastHero = isMobile
          ? window.scrollY > 72
          : hero
            ? hero.getBoundingClientRect().bottom < window.innerHeight * 0.35
            : window.scrollY > 280;

        if (!('IntersectionObserver' in window)) {
          setShopActive(isShopVisibleFallback());
        }
        setStickyShown(pastHero && !shopActive);
        return;
      }

      /* product mode */
      if (!form || !mainProduct) {
        setStickyShown(false);
        return;
      }

      var rect = form.getBoundingClientRect();
      var footer = document.querySelector('.shopify-section--footer');
      var footerVisible = false;
      if (footer) {
        var fr = footer.getBoundingClientRect();
        footerVisible = fr.top < window.innerHeight;
      }

      var formPastTop = rect.bottom < 0;
      var formInView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
      var scrolled = window.scrollY > (mobileQuery.matches ? 120 : 200);

      setStickyShown(scrolled && formPastTop && !footerVisible);
      if (!formPastTop && formInView) setStickyShown(false);
    }

    if (mode === 'landing' && mainProduct && 'IntersectionObserver' in window) {
      var shopObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setShopActive(entry.isIntersecting);
            updateVisibility();
          });
        },
        { threshold: 0, rootMargin: '-30% 0px -32% 0px' }
      );
      shopObserver.observe(mainProduct);
    }

    if (mode === 'product' && form && 'IntersectionObserver' in window) {
      var formObserver = new IntersectionObserver(
        function () {
          updateVisibility();
        },
        { threshold: [0, 0.15, 0.5, 1] }
      );
      formObserver.observe(form);
      var footer = document.querySelector('.shopify-section--footer');
      if (footer) formObserver.observe(footer);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    mobileQuery.addEventListener('change', updateVisibility);
    updateVisibility();

    var gallerySection = document.querySelector(
      bar.getAttribute('data-section-selector') || '.shopify-section--main-product'
    );

    function onSync() {
      syncFromDom(bar, form);
    }

    function syncMediaNow() {
      if (!gallerySection) return;
      syncStickyMedia(bar, gallerySection, form);
    }

    if (form && form.id) {
      window.__nvStickyCartSyncByForm = window.__nvStickyCartSyncByForm || {};
      window.__nvStickyCartSyncByForm[form.id] = syncMediaNow;
    }

    function onVariantChange(event) {
      var detail = event.detail || {};
      if (form && detail.formId && detail.formId !== form.id) return;
      syncMediaNow();
      if (detail.variant) updateFromVariant(bar, detail.variant, form);
      if (form) syncAtcColor(form, bar);
      onSync();
      requestAnimationFrame(function () {
        syncMediaNow();
        if (detail.variant) updateFromVariant(bar, detail.variant, form);
      });
      setTimeout(syncMediaNow, 50);
      setTimeout(syncMediaNow, 200);
      setTimeout(syncMediaNow, 450);
    }

    onSync();
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('product:variant-change', onVariantChange);
    document.addEventListener('product:rerender', function (event) {
      if (form && event.target === form) {
        setTimeout(onSync, 0);
        setTimeout(syncMediaNow, 80);
      }
    });

    if (form) {
      form.addEventListener('product:rerender', function () {
        setTimeout(syncMediaNow, 80);
      });

      var colorGroup = findColorGroup(form);
      if (colorGroup) {
        colorGroup.addEventListener('change', function () {
          syncMediaNow();
          syncAtcColor(form, bar);
        });
        colorGroup.addEventListener(
          'click',
          function () {
            requestAnimationFrame(syncMediaNow);
          },
          true
        );
      }

      var picker =
        document.querySelector('variant-picker[form-id="' + form.id + '"]') ||
        document.querySelector('variant-picker[form="' + form.id + '"]');
      if (picker) {
        picker.addEventListener('change', function () {
          requestAnimationFrame(syncMediaNow);
        });
        picker.addEventListener(
          'click',
          function (event) {
            if (
              event.target.closest(
                'label[for], .color-swatch, .block-swatch, .thumbnail-swatch'
              )
            ) {
              requestAnimationFrame(syncMediaNow);
            }
          },
          true
        );
      }
    }

    if (gallerySection) {
      var onGalleryChange = syncMediaNow;
      ['carousel:change', 'carousel:settle', 'carousel:select'].forEach(function (evt) {
        gallerySection.addEventListener(evt, onGalleryChange);
        gallerySection.querySelectorAll('scroll-carousel').forEach(function (carousel) {
          carousel.addEventListener(evt, onGalleryChange);
        });
      });
    }

    var productInfo = document.querySelector('.shopify-section--main-product .product-info');
    if (productInfo && 'MutationObserver' in window) {
      var moTimer;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(function () {
          syncMediaNow();
          onSync();
        }, 60);
      }).observe(productInfo, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (mode === 'landing' && shopAnchor) {
      bar.querySelectorAll('[data-nv-sticky-atc]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = document.getElementById(shopAnchor);
          if (!target) return;
          event.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 72;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-nv-sticky-cart]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
